/**
 * Base manufacturer implementation providing common functionality
 */

import {
  Machine,
  ManufacturerPlugin,
  RobotKinematics,
  RobotManufacturer,
  TeachIOMapping,
} from '../robot.types';

/**
 * Abstract base class for robot manufacturers
 */
export abstract class AbstractManufacturerPlugin<RobotModel = string>
  implements ManufacturerPlugin<RobotModel>
{
  public abstract getManufacturer(): RobotManufacturer;

  public abstract getManufacturerDisplayName(): string;

  public abstract getModels(): RobotModel[];

  public getModelByNumber(modelNumber?: string | null): RobotModel | undefined {
    return this.getModels().find(
      (model) => model === modelNumber?.toUpperCase()
    );
  }

  public isValidModel(modelNumber?: string | null): boolean {
    return this.getModelByNumber(modelNumber) !== undefined;
  }

  public getKinematics(
    _modelNumber?: string | null
  ): RobotKinematics | undefined {
    return;
  }

  public abstract getDefaultIOMapping(machine: Machine): TeachIOMapping;
}
